module.exports = __webpack_public_path__ + "img/张慧敬.8a4959a6.jpg";